module.exports = __webpack_public_path__ + "static/media/ewm-left.cf024369.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newPeople/ewm-left.png
// module id = 1987
// module chunks = 6